import React from "react";
import { motion } from "framer-motion";

function MarketingFeatures() {
  const features = [
    {
      title: "Search Engine Optimization (SEO)",
      description:
        "Boost your website’s visibility on search engines with proven SEO strategies that drive organic traffic and improve rankings.",
      color: "#1E88E5",
    },
    {
      title: "Social Media Marketing",
      description:
        "Engage your audience and build brand loyalty through targeted campaigns across platforms like Facebook, Instagram, LinkedIn, and Twitter.",
      color: "#43A047",
    },
    {
      title: "Pay-Per-Click Advertising (PPC)",
      description:
        "Maximize ROI with data-driven PPC campaigns on Google Ads, Facebook Ads, and other platforms to generate high-quality leads.",
      color: "#FB8C00",
    },
    {
      title: "Content Marketing",
      description:
        "Create and distribute valuable, relevant, and consistent content to attract, inform, and convert your target audience.",
      color: "#8E24AA",
    },
    {
      title: "Email Marketing & Automation",
      description:
        "Nurture leads and retain customers with personalized, automated email campaigns that deliver the right message at the right time.",
      color: "#00ACC1",
    },
    {
      title: "Analytics & Performance Tracking",
      description:
        "Leverage advanced analytics to monitor campaign performance, gain actionable insights, and continually optimize results.",
      color: "#F4511E",
    },
  ];

  // Smooth animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.35,
        duration: 1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 1, ease: "easeInOut" },
    },
  };

  const styles = {
    container: {
      padding: "60px 20px",
      textAlign: "center",
      background: "#f8f9fa",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    heading: {
      fontSize: "32px",
      marginBottom: "40px",
      fontWeight: "bold",
      letterSpacing: "0px",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "25px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    card: {
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
      padding: "25px",
      textAlign: "left",
      transition: "all 0.3s ease",
      borderLeft: "8px solid transparent",
      minHeight: "200px",
      cursor: "pointer",
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "15px",
      color: "#1e40af",
    },
    desc: {
      fontSize: "15px",
      lineHeight: "1.6",
      textAlign: "justify",
      color: "#4b5563",
    },
  };

  return (
    <div style={styles.container}>
      <motion.h2
        style={styles.heading}
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1, ease: "easeInOut" }}
      >
        Key Features of Our Digital Marketing Solutions
      </motion.h2>

      <motion.div
        style={styles.grid}
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
      >
        {features.map((feature, index) => (
          <motion.div
            key={index}
            variants={cardVariants}
            style={{
              ...styles.card,
              borderLeft: `8px solid ${feature.color}`,
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderLeft = `16px solid ${feature.color}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderLeft = `8px solid ${feature.color}`;
            }}
          >
            <h3 style={styles.title}>{feature.title}</h3>
            <p style={styles.desc}>{feature.description}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}

export default MarketingFeatures;
